import { jsx as t } from "react/jsx-runtime";
import s from "react";
import "axios";
import { isEmpty as e } from "./index22.js";
import { parseClassNames as p } from "./index21.js";
import "react-dom";
import "./index23.js";
import { Text as a } from "./index24.js";
import "./index25.js";
const F = ({ id: m, hint: r, className: i }) => {
  if (e(r))
    return null;
  const o = p(["input-hint", i]);
  return /* @__PURE__ */ t("div", { id: m, className: o, children: s.isValidElement(r) ? r : /* @__PURE__ */ t(a, { tiny: !0, children: r }) });
};
export {
  F as FormFieldHint
};
